<template lang="html">
  <item-editor-dialog
    :id="selectedItemId"
    ref="editForm"
    v-model="selectedPanel"
    :show="showItem"
    :clone-id="cloneId"
    :title="pageTitle"
    :on-close="doClose"
    :context-menu="defaultContextMenu"
    :lock-timer="lockTimerSettings"
    :loading="isDataLoading"
    :errors="errors"
    :edit-panel-id="editPanel"
    :audit-panel-id="auditPanel"
    :audit="auditHistorySettings"
    :buttons="pageBarButtons"
  >
    <!-- START OF FORM FIELDS -->
    <v-flex class="pa-3">
      <v-text-field
        v-model.trim="itemData.name"
        :label="type + ' Name'"
        :rules="rules().required('Name')"
        :error-messages="getPathErrors(jsonPath, 'name')"
        :disabled="isFormDisabled"
        required
        @input="clearPathErrors(jsonPath, 'name')"
      />

      <v-select
        v-model="itemData.appMode"
        prepend-icon="mdi-cog-box"
        label="Type"
        :readonly="true"
        :items="appModes.filter(a=>a.value===$ftAPI().appMode() || a.value===itemData.appMode)"
      />

      <detail-editor-table
        v-model="itemData.staff"
        type="Group Member"
        :json-path="buildJsonPath('staff')"
        :get-path-errors="getPathErrors"
        :clear-path-errors="clearPathErrors"
        :move-path-errors="movePathErrors"
        :disabled="isFormDisabled"
        :item-default="{
          staffId: null,
          terminalGroupId: itemData.id,
          disabled: false
        }"
        :headers="[
          headerEditor({label: '', field: 'photoUrlFull', editor: {type: 'slot'}, thin: true}),
          headerEditor({label: 'Staff', field: 'staffId', editor: {type: 'slot'}}),
          headerEditor({label: 'Enabled', field: 'disabled', editor: {type: 'switch', invert: true}, thin: true})
        ]"
        @error="addError"
      >
        <template
          slot="photoUrlFull"
          slot-scope="props"
        >
          <v-avatar>
            <img
              v-if="staffIdMap[props.item.staffId] && staffIdMap[props.item.staffId].photoUrlFull"
              :src="staffIdMap[props.item.staffId].photoUrlFull"
            ><v-icon
              v-else
              size="55"
              color="grey darken-1"
            >
              mdi-account-circle
            </v-icon>
          </v-avatar>
        </template>
        <template
          slot="staffId"
          slot-scope="props"
        >
          <v-autocomplete
            placeholder="Staff"
            :items="staff.filter(s => !usedStaffMap[s.id] || s.id === props.item.staffId)"
            :value="props.item.staffId"
            :clearable="false"
            auto
            :error-messages="props.errorMessages"
            :disabled="isFormDisabled"
            required
            item-text="nameProper"
            item-value="id"
            @input="props.setCellValue(props.item, props.header.value, props.header.editor, props.row, $event)"
          >
            <template v-slot:item="{ item }">
              <v-avatar class="ma-1">
                <img
                  v-if="item.photoUrlFull"
                  :src="item.photoUrlFull"
                ><v-icon
                  v-else
                  size="55"
                  color="grey darken-1"
                >
                  mdi-account-circle
                </v-icon>
              </v-avatar>
              <span>{{ item.nameProper }}</span>
            </template>
          </v-autocomplete>
        </template>
      </detail-editor-table>

      <v-textarea
        v-model.trim="itemData.notes"
        label="Comments"
        :rows="1"
        auto-grow
        :error-messages="getPathErrors(jsonPath, 'notes')"
        :disabled="isFormDisabled"
        @input="clearPathErrors(jsonPath, 'notes')"
      />

      <v-boolean
        v-model="itemData.disabled"
        label="Enabled"
        invert
        :error-messages="getPathErrors(jsonPath, 'disabled')"
        :field-errors="getPathErrors(jsonPath, 'disabled')"
        :disabled="isFormDisabled"
      />
    </v-flex>
    <!-- END OF FORM FIELDS -->
  </item-editor-dialog>
</template>

<script>
import {itemEdit, withChildren} from '@/ft-vue-core'

var itemDefault = {
  name: '',
  notes: '',
  disabled: false,
  appMode: null,
  id: null,
  staff: [],
  recordLockExpiration: null
}

export default {
  name: 'TerminalGroupItem',
  components: {
  },
  mixins: [itemEdit, withChildren],
  data: function () {
    return {
      type: 'Terminal Group',
      types: 'Terminal Groups',
      apiRecordCommand: 'terminalGroup',
      itemDefault: itemDefault,
      appModes: [],
      staff: []
    }
  },
  computed: {
    staffIdMap () {
      return this.staff.reduce((acc, b) => {
        acc[b.id] = b
        return acc
      }, {})
    },
    usedStaffMap () {
      return this.itemData.staff.reduce((acc, b) => {
        acc[b.staffId] = b
        return acc
      }, {})
    }
  },
  methods: {
    itemResourceCommands () {
      return [
        {
          command: 'apiFieldOption',
          load: this.appModes,
          loading: this.isLoading,
          params: {filter_methods: {forField: ['terminalGroup', 'appMode']}}
        },
        {
          command: 'staff',
          load: this.staff,
          loading: this.isLoading,
          params: {
            filter_methods: {filterAppMode: [this.$ftAPI().appMode()]},
            include_fields: ['id', 'nameProper', 'photoUrlFull', 'disabled']
          }
        }
      ]
    },
    resetLocalValues (keepItemData) {
      this.itemDefault.appMode = this.$ftAPI().appMode()
    }
  }
}
</script>
